<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center">
      <p>{{$t('chainProduct.confirmDeleteProduct')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="deleteChainProduct">{{$t('common.confirmDelete')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteChainProduct } from '@/api/admin/chainProduct/chainProductApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteChainProduct',
  data() {
    return {
      dialogVisible: false,
      deleteChainProductInfo: {
        productId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(product) {
      this.dialogVisible = true
      this.deleteChainProductInfo = {
        productId: product.productId,
        shopId: getShopId()
      }
    },
    deleteChainProduct() {
      deleteChainProduct(this.deleteChainProductInfo).then(response => {
        const res = response.data
        if (res.code === 0) {
          this.$message.success(this.$t('common.deleteSuccess'))
          this.dialogVisible = false
          this.$emit('listChainProduct')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    handleClose() {
      this.deleteChainProductInfo = {
        productId: '',
        shopId: ''
      }
    }
  }
}
</script>